// mall (qoo10 / rakuten / au-pay) ごとに振る舞いが変わる部分をここに集約する。
//
// application.jsx は本ファイルからのみ mall 固有 import / 関数を取得することで
// 3 ブランチ (frontend/admin-lte-removal = qoo10 / -rakuten / develop = au-pay)
// 間で application.jsx 自体は同一に保たれ、ブランチ間 merge が容易になる。
//
// 本ファイルだけがブランチ間で差分を持つことになるので、ここを共通化しないこと。
//
// === qoo10 (frontend/admin-lte-removal) 版 ===
// qoo10 では mall 固有の追加処理がほぼ無く、すべて no-op スタブ。

import PriceSettings from "./PriceSettings";

// 価格自動設定 UI のコンポーネント
// rakuten 側は PriceSettingsSets を、qoo10 / au-pay は PriceSettings を使用
export const MallPriceSettings = PriceSettings;

// CSV ダウンロードボタン (bulk-action) の form を準備する直前のフック
// rakuten では trigger.dataset を全て hidden として form に投入する
export const onCSVDownloadFormPrepared = (_form, _trigger) => {
    // qoo10: 何もしない
};

// #bulk-price-setting-form の submit ハンドラ
// rakuten では選択商品 ID を hidden として form に投入してから submit
// qoo10 では submit を抑止するだけ
export const onBulkPriceSettingFormSubmit = (_form, e) => {
    e.preventDefault();
    return false;
};

// onReady() の最後に呼ばれる mall 固有初期化
// rakuten では .amazon-category クリック、.rakuten-attributes マウント等
export const mallInit = (_ctx) => {
    // qoo10: 何もしない
};
